<div class="select-account" [class.disabled]="isDisabled">
  <div class="select-account__selected" *ngIf="selectedAccount; else searchInput">
    <ng-container *ngTemplateOutlet="accountRow; context: { account: selectedAccount }"></ng-container>
    <button
      type="button"
      class="select-account__clear"
      [disabled]="isDisabled"
      (click)="clearSelection()"
    >
      &times;
    </button>
  </div>

  <ng-template #searchInput>
    <input
      type="text"
      class="select-account__input"
      [formControl]="searchCtrl"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      (focus)="onFocus()"
    />
  </ng-template>

  <div class="select-account__dropdown" *ngIf="isOpen && !selectedAccount">
    <div class="select-account__loading" *ngIf="isLoading">Buscando...</div>

    <ng-container *ngIf="!isLoading">
      <div
        class="select-account__item select-account__item--option"
        *ngFor="let account of results"
        (click)="onSelect(account)"
      >
        <ng-container *ngTemplateOutlet="accountRow; context: { account: account }"></ng-container>
      </div>

      <div class="select-account__empty" *ngIf="!results.length && searchCtrl.value">
        Nenhuma conta encontrada
      </div>
    </ng-container>
  </div>
</div>

<ng-template #accountRow let-account="account">
  <div class="select-account__row">
    <app-avatar class="select-account__avatar" [text]="account.name" diameter="32px" fontSize="12px"></app-avatar>
    <div class="select-account__info">
      <div class="select-account__title" [title]="account.name">{{ account.name | uppercase }}</div>
      <div class="select-account__subtitle" *ngIf="account.email" [title]="account.email">
        {{ account.email }}
      </div>
    </div>
  </div>
</ng-template>
